<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-commodity__commodity}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="请输入ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('commodity:commodity:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('commodity:commodity:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-popover
            placement="bottom"
            width="300"
            trigger="click"
            v-model="columnFilterVisible">
            <div class="column-filter-panel">
              <div class="filter-header">
                <span>列显示设置</span>
                <el-button type="text" size="small" @click="resetColumns">重置</el-button>
              </div>
              <el-checkbox-group v-model="selectedColumns" class="filter-checkboxes">
                <el-checkbox
                  v-for="col in allColumns"
                  :key="col.prop"
                  :label="col.prop"
                  :disabled="col.required">
                  {{ col.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <el-button slot="reference" icon="el-icon-setting">列筛选</el-button>
          </el-popover>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;" :fit="true">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column v-if="isColumnVisible('id')" prop="id" label="主键ID" min-width="180" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('duration')" prop="duration" label="显示名称" min-width="150" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('price')" prop="price" label="商品价格" min-width="120" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('commoditySpecification')" prop="commoditySpecification" min-width="120" label="商品规格" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('commodityToSort')" prop="commodityToSort" label="商品排序" min-width="110" header-align="center" align="center"></el-table-column>
        <!-- 默认商品Switch列 -->
        <el-table-column v-if="isColumnVisible('isDefault')" label="兜底默认" min-width="110" header-align="center" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.isDefault === 1"
              :disabled="scope.row.isDefault === 1"
              @change="handleSetDefault(scope.row.id, 3)"
            />
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('isDefaultEntry1')" label="我的页面默认" min-width="130" header-align="center" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.isDefaultEntry1 === 1"
              :disabled="scope.row.isDefaultEntry1 === 1"
              @change="handleSetDefault(scope.row.id, 1)"
            />
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('isDefaultEntry2')" label="广告弹框默认" min-width="130" header-align="center" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.isDefaultEntry2 === 1"
              :disabled="scope.row.isDefaultEntry2 === 1"
              @change="handleSetDefault(scope.row.id, 2)"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column prop="type" label="商品类型(1:钻石  2:VIP)" header-align="center" align="center"></el-table-column> -->
        <el-table-column v-if="isColumnVisible('type')" prop="type" label="商品类型" min-width="110" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1">钻石</el-tag>
            <el-tag v-if="scope.row.type === 2" size="success" type="success">VIP</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status" label="是否开启(1:是  2:否)" header-align="center" align="center"></el-table-column> -->
        <el-table-column v-if="isColumnVisible('status')" prop="status" label="是否开启" min-width="110" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" size="success" type="success">是</el-tag>
            <el-tag v-if="scope.row.status === 2" size="warning" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('time')" prop="time" label="创建时间" min-width="180" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('commodity:commodity:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('commodity:commodity:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './commodity-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/commodity/commodity/page',
        getDataListIsPage: true,
        exportURL: '/commodity/commodity/export',
        deleteURL: '/commodity/commodity',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      // 列筛选相关
      columnFilterVisible: false,
      allColumns: [
        { prop: 'id', label: '主键ID', required: false },
        { prop: 'duration', label: '显示名称', required: false },
        { prop: 'price', label: '商品价格', required: false },
        { prop: 'commoditySpecification', label: '商品规格', required: false },
        { prop: 'commodityToSort', label: '商品排序', required: false },
        { prop: 'isDefault', label: '兜底默认', required: false },
        { prop: 'isDefaultEntry1', label: '我的页面默认', required: false },
        { prop: 'isDefaultEntry2', label: '广告弹框默认', required: false },
        { prop: 'type', label: '商品类型', required: false },
        { prop: 'status', label: '是否开启', required: false },
        { prop: 'time', label: '创建时间', required: false }
      ],
      selectedColumns: []
    }
  },
  created() {
    this.initSelectedColumns()
  },
  components: {
    AddOrUpdate
  },
  watch: {
    selectedColumns: {
      handler() {
        this.saveColumnSettings()
      },
      deep: true
    }
  },
  methods: {
    // 初始化选中的列
    initSelectedColumns() {
      const savedColumns = localStorage.getItem('commodity_selected_columns')
      if (savedColumns) {
        this.selectedColumns = JSON.parse(savedColumns)
      } else {
        this.selectedColumns = this.allColumns.map(col => col.prop)
      }
    },

    // 判断列是否可见
    isColumnVisible(prop) {
      return this.selectedColumns.includes(prop)
    },

    // 重置列设置
    resetColumns() {
      this.selectedColumns = this.allColumns.map(col => col.prop)
      this.saveColumnSettings()
      this.$message.success('已重置列显示设置')
    },

    // 保存列设置
    saveColumnSettings() {
      localStorage.setItem('commodity_selected_columns', JSON.stringify(this.selectedColumns))
    },

    /**
     * 设置默认商品
     * @param {Number} commodityId 商品ID
     * @param {Number} defaultType 默认类型 (1=entry1我的页面, 2=entry2广告弹框, 3=default兜底)
     */
    async handleSetDefault(commodityId, defaultType) {
      try {
        // 调用后端API设置默认商品
        await this.$http.put('/commodity/commodity/setDefault', null, {
          params: { commodityId, defaultType }
        })

        // 提示成功
        this.$message.success('设置成功')

        // 刷新列表以显示最新状态
        this.getDataList()
      } catch (err) {
        // 错误处理
        console.error('设置默认商品失败:', err)
        this.$message.error('设置失败: ' + (err.msg || err.message || '未知错误'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.column-filter-panel {
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;

    span {
      font-weight: 600;
      color: #303133;
    }
  }

  .filter-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .el-checkbox {
      margin-right: 0;
      margin-left: 0;
    }
  }
}
</style>
